
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import InternalAuthForm from '@/components/auth/InternalAuthForm';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { useAuth } from '@/hooks/useAuth';

const Register = () => {
  const navigate = useNavigate();
  const { user: internalUser, loading: internalLoading } = useInternalAuth();
  const { user: supabaseUser, loading: supabaseLoading } = useAuth();
  const isMobile = useIsMobile();

  // Auto-scroll to top when component mounts to ensure form is visible
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // Redirect authenticated users to appropriate dashboard
  useEffect(() => {
    if (!internalLoading && !supabaseLoading) {
      if (internalUser) {
        console.log('Internal user authenticated, redirecting to internal dashboard');
        // Small delay to ensure profile is loaded
        const timer = setTimeout(() => {
          navigate('/internal-dashboard');
        }, 100);
        return () => clearTimeout(timer);
      } else if (supabaseUser) {
        console.log('Supabase user authenticated, redirecting to dashboard');
        // Small delay to ensure profile is loaded
        const timer = setTimeout(() => {
          navigate('/dashboard');
        }, 100);
        return () => clearTimeout(timer);
      }
    }
  }, [internalUser, supabaseUser, internalLoading, supabaseLoading, navigate]);

  // Show loading while checking authentication
  if (internalLoading || supabaseLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-black">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  // Don't render the form if user is authenticated (prevents flash)
  if (internalUser || supabaseUser) {
    return null;
  }

  return (
    <div className="flex flex-col min-h-screen bg-black w-full">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className="flex-grow mt-24 flex items-center justify-center py-6 md:py-12 w-full px-4 md:px-6 pb-20 md:pb-6">
        <div className="w-full max-w-4xl mx-auto">
          <InternalAuthForm />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default Register;
